import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import { choose } from '../../utils/platform';
import { useFamilies } from './useFamilies';
import FamiliesDesktop from './Families.desktop';
import FamiliesMobile from './Families.mobile';

const FamiliesView = choose(FamiliesDesktop, FamiliesMobile);

function FamiliesInner({ event }) {
  const vm = useFamilies(event);
  return <FamiliesView vm={vm} />;
}

export default function Families() {
  return <RequireEvent>{(event) => <FamiliesInner event={event} />}</RequireEvent>;
}
